import { cn } from "@/lib/utils";
import {
  ITEM_QUALITY_STATE_LABELS,
  itemQualitySegments,
  itemQualityStateClass,
} from "@/utils/socratesCriteria";

export interface ItemQualitySummaryProps {
  passed: number;
  failed: number;
  notEvaluated: number;
  judgment: number;
}

/** The "Item Quality: 16 passed" summary line, shared by the item card and the
 *  Edit modal so the two surfaces can't drift (ARC-223 Change 3). Each
 *  non-zero state renders once, in the fixed order passed, failed, not
 *  evaluated, needs your judgment, and is coloured to match that state's
 *  criteria-grid marker. States with a count of zero are omitted entirely —
 *  naming every state makes the old denominator unnecessary. */
export function ItemQualitySummary({
  passed,
  failed,
  notEvaluated,
  judgment,
}: ItemQualitySummaryProps) {
  const segments = itemQualitySegments(passed, failed, notEvaluated, judgment);
  const rendered: Array<React.ReactElement> = [];
  for (let i = 0; i < segments.length; i++) {
    const { state, count } = segments[i];
    if (i > 0) {
      rendered.push(<span key={`separator-${state}`}>{", "}</span>);
    }
    rendered.push(
      <span
        key={state}
        data-testid={`item-quality-state-${state}`}
        className={cn("font-medium", itemQualityStateClass(state))}
      >
        {count} {ITEM_QUALITY_STATE_LABELS[state]}
      </span>
    );
  }
  return (
    <>
      Item Quality:{" "}
      {rendered}
    </>
  );
}